module.exports = "/assets/data/c3ebe0a11eb1c2428eb6b40aa752e03a-MK17.data.json";